import { gql } from '@lcs/shared/api';

export const saveMailboxMessageMutation = gql`
   mutation SaveMailboxMessage($mailboxMessage: MailboxMessageInput!) {
      mailboxMessage: saveMailboxMessage(mailboxMessage: $mailboxMessage) {
         mailboxMessageId
         isRead
         isArchived
         mailboxFolderId
      }
   }
`;

export const saveMailboxMessagesMutation = gql`
   mutation SaveMailboxMessages($mailboxMessages: [MailboxMessageInput!]!) {
      mailboxMessages: saveMailboxMessages(mailboxMessages: $mailboxMessages) {
         mailboxMessageId
         isRead
         isArchived
      }
   }
`;
